export { default } from './LogoutWide'
